import React from 'react';
import img$3 from '../../assets/images/p_logo.svg.js';
import img$1 from '../../assets/images/logo-portail.svg.js';
import img from '../../assets/images/logo-portaal.svg.js';
import img$2 from '../../assets/images/logo-nt2.svg.js';
import { Button } from '../button/index.js';
import styles from './maintenance-page.module.css.js';

const MaintenancePage = (props) => {
    const { translations, studioGroup } = props;
    const renderAction = () => {
        if (!('action' in props) || !props?.action)
            return null;
        const handleActionClick = () => {
            location.assign(props.redirectUrl);
        };
        return (React.createElement(Button, { onClick: handleActionClick, className: styles.button }, props.action));
    };
    const renderLogo = () => {
        if (studioGroup === 'SO')
            return React.createElement("img", { className: styles.img, src: img, alt: 'Portaal Logo' });
        if (studioGroup === 'ES')
            return React.createElement("img", { className: styles.img, src: img$1, alt: 'Portail Logo' });
        if (studioGroup === 'VO')
            return React.createElement("img", { className: styles.img, src: img$2, alt: 'Zogezegd Logo' });
        return React.createElement("img", { className: styles.img, src: img$3, alt: 'Pelckmans Logo' });
    };
    return (React.createElement("div", { "data-testid": 'maintenance-page', className: styles.maintenancePage },
        renderLogo(),
        React.createElement("h1", { className: 'maintenance-page__header' }, translations.title),
        React.createElement("p", { className: 'maintenance-page__paragraph', dangerouslySetInnerHTML: { __html: translations.message } }),
        renderAction()));
};

export { MaintenancePage };
